export default "__VITE_ASSET__DwEZq8B$__"